import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PENDING_CUSTOMS_DOCUMENTS_VIEW_ID, SHIPPED_VIEW_ID } from './view-id-constants';

export const pendingCustomsDocumentsView = {
  label: <FormattedMessage defaultMessage='Pending Customs Documents' description='ordersPage.nav.pendingCustomsDocuments' id='uklZc/' />,
  id: PENDING_CUSTOMS_DOCUMENTS_VIEW_ID,
  expandedDescription: (
    <FormattedMessage
      defaultMessage='Shipped / Pending Customs Documents'
      description='ordersPage.nav.pendingCustomsDocumentsExpanded'
      id='quHdfX'
    />
  ),
  parentId: SHIPPED_VIEW_ID,
};
